import { render, staticRenderFns } from "./VirtualVisit.vue?vue&type=template&id=22fb3f2a"
import script from "./VirtualVisit.vue?vue&type=script&lang=js"
export * from "./VirtualVisit.vue?vue&type=script&lang=js"
import style0 from "./VirtualVisit.vue?vue&type=style&index=0&id=22fb3f2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports